const state = {
  topics: [],
  categories: [],
  authors: [],
  header: []
};

const mutations = {
  SET_TOPICS(state, payload) {
    state.topics = payload.videos;
    state.categories = payload.categorias;
    state.authors = payload.authors;
  },
  SET_HEADER_CONTENT(state, payload) {
    state.header = payload;
  }
};

const actions = {
  initTopics: ({ commit }, payload) => {
    commit("SET_TOPICS", payload);
  },
  initHeader: ({ commit }, payload) => {
    commit("SET_HEADER_CONTENT", payload);
  }
};

const getters = {
  topics: state => {
    return state.topics;
  },
  categories: state => {
    return state.categories;
  },
  authors: state => {
    return state.authors;
  },
  header: state => state.header,
  getAuthorById: state => idAuthor => {
    return state.authors.find(author => author.id === idAuthor);
  },
  getTopicInfo: state => idVideo => {
    return state.topics.find(topic => topic.id === idVideo);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
